import { Company } from '../models/response/prospect/company';

export class CompanyUtils {

  static brand(company?: Company): string {
    return (company?.brand || company?.name || '').trim();
  }

  static brands(companies: Company[]): string[] {
    const brandsByKey: { [key: string]: string } = {};
    (companies || []).forEach(company => {
      const brand = CompanyUtils.brand(company);
      const key = CompanyUtils.normalize(brand);
      if (key && !brandsByKey[key]) {
        brandsByKey[key] = brand;
      }
    });
    return Object.keys(brandsByKey)
      .map(key => brandsByKey[key])
      .sort((left, right) => left.localeCompare(right));
  }

  static filterByBrand(companies: Company[], brand: string): Company[] {
    const normalizedBrand = CompanyUtils.normalize(brand);
    if (!normalizedBrand) {
      return [];
    }
    return (companies || [])
      .filter(company => CompanyUtils.normalize(CompanyUtils.brand(company)) === normalizedBrand)
      .sort((left, right) => (left.name || '').localeCompare(right.name || ''));
  }

  private static normalize(value: string): string {
    return (value || '').trim().toLowerCase();
  }
}
